<template>
  <div class="chained-select-chart">
    <i class="el-icon-info"> 点击选项可查看下一级</i>
    <el-row>
      <el-button size="small" @click="handleReset">重置</el-button>
      <el-button size="small" @click="handlePrev" v-if="prevGroups.length > 0">上一级</el-button>
      <el-table
        :data="groupsDisp"
        style="width: 100%">
        <el-table-column
          prop="value"
          label="选项"
          width="600">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="handleClickLevel(scope.row, scope.$index)">{{scope.row.value}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="小计">
        </el-table-column>
        <el-table-column
          prop="rate"
          label="百分比">
          <template slot-scope='scope'>
            {{ (scope.row.rate * 100).toFixed(1) }}%
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'chainedSelectChart',
  props: ['quesInfo'],
  data() {
    return {
      prevGroups: [],
      groupsDisp: this.quesInfo.groups
    }
  },
  methods: {
    handleClickLevel(row, index) {
      if (this.groupsDisp[index].children.length > 0) {
        this.prevGroups.push(this.groupsDisp);
        this.groupsDisp = this.groupsDisp[index].children;
      }
    },
    handleReset() {
      this.prevGroups = [];
      this.groupsDisp = this.quesInfo.groups;
    },
    handlePrev() {
      this.groupsDisp = this.prevGroups.pop();
    },
  }
}
</script>
<style lang="scss">
  .chained-select-chart {
    .el-icon-info {
      color: #999;
      margin-bottom: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/singleAnalysis/chainedSelectChart.vue